import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import classNames from 'classnames';
const classButtonInactive = 'btn btn-primary btn-block';
import * as actions from '../../../actions/response';
import {converter} from '../../../helpers/converter';
import CustomInputClaro from '../../forms/CustomInputClaro';
import FormValidations from '../../../../react/data/FormValidations';



class ModalEmailIpTelmex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        emailExist:'Email error',
        useOther: false,
        form:{
          email:'',
        },
        errors: {
        }
    }
    
    this.setFormState = this.setFormState.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps)  {
    if ( nextProps.emailExist ) {
      Object.assign(this.state.errors,
      new FormValidations(this.state.form.email, 'email')
        .setError(nextProps.emailExist.error)
        .getErrors());
    }
  }
  
  isValidForm() {
    var formValid = true;
    this.state.errors = {};
      
    Object.assign(this.state.errors,
    new FormValidations(this.state.form.email, 'email')
      .validateEmailFormat(converter.convertApaUnicode(this.props.translations, 'registro_valido_mail', 'Ingresa un email valido.'))
      .getErrors());

    if (Object.keys(this.state.errors).length !== 0) {
      formValid = false;
    }

    this.setState({errors: this.state.errors});
    return formValid;
 }

  onSave(event) {
      event.preventDefault();
      if (!this.isValidForm()) {
        return;
      }

      this.onAccept(event, this.props.onSend);
  }

  setFormState(event) {
    this.state.form[event.target.name] = event.target.value;
    return this.setState({form: this.state.form});
  }

  closeModal() {
    this.props.closeModal("EmailIpTelmex");
  }

  onAccept(e, cb) {
    e.preventDefault();
    if (!cb) return this.closeModal();
    const scope = this;
    return cb(scope, this.state.form);
  }

  render() {
    const customIconClass = (this.props.iconClass) ? this.props.iconClass : false;

    const classes = {
      fa: true,
      'text-center': true,
      'fa-3x': true,
      'fa-check': !customIconClass,
    };

    if (customIconClass)
      classes[customIconClass] = customIconClass;

    const classesForBody = classNames(classes);

    return (
      <Modal show={true}>
        <Modal.Header>
          <Button className="close close-modal" onClick={this.closeModal}>x</Button>
          <h4 className="text-center">{this.props.title}</h4>
        </Modal.Header>
        <Modal.Body className='modal-body text-center success'>
          <i className={classesForBody}></i>
          <p className='padding-top-2' dangerouslySetInnerHTML={
              {__html: this.props.messageAccept }
            }></p>
          
          <Button
                className={ classButtonInactive }
                onClick={ (e) => this.onAccept(e, this.props.onAccept)}>
                {converter.convertApaUnicode(this.props.translations, 'registro_aceptar', 'Aceptar')}
          </Button>

          <p className='padding-top-2' dangerouslySetInnerHTML={
              {__html: this.props.messageSend }
            }></p>

           <form className="form-paso1" onSubmit={ this.validatePIN }>
            <CustomInputClaro
              idElement="email"
              inputType="text"
              placeholderText="email"            
              onChange={this.setFormState}
              value={this.state.form.email}
              error={this.state.errors.email}
            />
          </form>
        
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12 padding-top-05 text-center">
              <Button
                className={ classButtonInactive }
                onClick={this.onSave.bind(this) }>
                {converter.convertApaUnicode(this.props.translations, 'registro_aceptar', 'Aceptar')}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    translations: state.translations,
    emailExist: state.user.errorEmailExist,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEmailIpTelmex);
